import { Map as ImmMap } from 'immutable';
import Customer from 'models/Customer';
import {
	IS_LOGGING_IN,
	IS_REGISTERING,
	LAST_ACTIVITY,
	LOGIN,
	LOGIN_ERROR,
	LOGOUT,
	REGISTER_ERROR,
} from './constants';

export const initialState = new ImmMap({
	customer: new Customer(),
	isLoggingIn: false,
	isRegistering: false,
	loginError: undefined,
	registerError: undefined,
});

const UserReducer = (state = initialState, action) => {
	switch (action.type) {
		case IS_LOGGING_IN:
			return state.set('isLoggingIn', action.isLoggingIn);
		case IS_REGISTERING:
			return state.set('isRegistering', action.isRegistering);
		case LAST_ACTIVITY: {
			// Note: since customer is not immutable, we cannot do a setIn here
			// state.setIn(['customer', action.lastActivity]) will throw an invalid
			// key path error.
			const cust = state.get('customer');
			const updatedCustomer = Object.assign(new Customer(), cust);
			updatedCustomer.lastActivity = action.lastActivity;
			return state.set('customer', updatedCustomer);
		}
		case LOGIN:
			return state.set('customer', action.customer);
		case LOGIN_ERROR:
			return state.set('loginError', action.loginError);
		case LOGOUT:
			// For a logout just overwrite with a new "guest" customer.
			return state.set('customer', new Customer());
		case REGISTER_ERROR:
			return state.set('registerError', action.registerError);
		default:
			return state;
	}
};

export default UserReducer;
